import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConversationSummary } from '../../../domain/models/conversation-summary.model';
import { ConversationListItemAction } from './conversation-list-item.component';

@Component({
  selector: 'talk-to-your-data-saved-conversations',
  templateUrl: './saved-conversations.component.html',
  styleUrls: ['./conversation-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedConversationsComponent {
  @Input() savedConversations: readonly ConversationSummary[] | null = [];
  @Input() selectedConversationId: string | null = null;
  @Output() readonly conversationSelected = new EventEmitter<string>();
  @Output() readonly conversationRemoved = new EventEmitter<string>();
  @Output() readonly conversationRenamed = new EventEmitter<{ conversationId: string; title: string }>();
  @Output() readonly conversationDeleted = new EventEmitter<string>();

  onMenuAction(action: ConversationListItemAction): void {
    switch (action.action) {
      case 'removePin':
        this.conversationRemoved.emit(action.conversationId);
        break;
      case 'rename':
        this.conversationRenamed.emit({ conversationId: action.conversationId, title: action.title });
        break;
      case 'delete':
        this.conversationDeleted.emit(action.conversationId);
        break;
    }
  }

  onConversationSelected(conversationId: string): void {
    this.conversationSelected.emit(conversationId);
  }

  trackByConversationId = (index: number, item: ConversationSummary): string =>
    item.conversationId || item.id || String(index);
}
